(function () {
  'use strict';
  if (window.__punkteReihe) return;
  window.__punkteReihe = true;

  var handy = window.matchMedia('(max-width: 1023px)');
  var PLUS = '<span class="pkr__zeichen-auf" aria-hidden="true">' +
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></span>';

  function einrichten() {
    document.querySelectorAll('.pkr.is-klappbar').forEach(function (reihe) {
      var an = handy.matches;
      reihe.classList.toggle('is-bereit', an);
      reihe.querySelectorAll('.pkr__punkt').forEach(function (punkt) {
        var kopf = punkt.querySelector('.pkr__kopf');
        var text = punkt.querySelector('.pkr__text');
        var knopf = punkt.querySelector('.pkr__auf');
        if (!kopf || !text) return;

        if (!an) {
          if (knopf) knopf.remove();
          punkt.classList.remove('is-offen', 'is-klappe');
          return;
        }

        punkt.classList.add('is-klappe');
        if (knopf) return;
        knopf = document.createElement('button');
        knopf.type = 'button';
        knopf.className = 'pkr__auf';
        knopf.setAttribute('aria-expanded', 'false');
        if (text.id) knopf.setAttribute('aria-controls', text.id);
        knopf.setAttribute('aria-label', kopf.textContent.trim());
        knopf.innerHTML = PLUS;
        kopf.appendChild(knopf);
      });
    });
  }

  function umschalten(punkt) {
    var reihe = punkt.closest('.pkr');
    var offen = punkt.classList.contains('is-offen');

    reihe.querySelectorAll('.pkr__punkt.is-offen').forEach(function (p) {
      p.classList.remove('is-offen');
      var k = p.querySelector('.pkr__auf');
      if (k) k.setAttribute('aria-expanded', 'false');
    });
    if (offen) return;

    punkt.classList.add('is-offen');
    var knopf = punkt.querySelector('.pkr__auf');
    if (knopf) knopf.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var kopf = e.target.closest('.pkr.is-klappbar.is-bereit .pkr__punkt.is-klappe .pkr__kopf');
    if (kopf) umschalten(kopf.closest('.pkr__punkt'));
  });

  if (handy.addEventListener) handy.addEventListener('change', einrichten);
  document.addEventListener('shopify:section:load', einrichten);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', einrichten);
  } else {
    einrichten();
  }
})();
